import { useEffect, useState } from 'react';
import { FormControl, FormLabel, Stack, Box, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackStyling,
    stackSpacing,
    descriptionStyling,
} from '@/components/forms/new/formStyles';

const SelectiveSyncToggle = ({ darkMode, serviceWizard }) => {
    const [isHovered, setIsHovered] = useState(false);
    const isSyncRequired = serviceWizard?.company?.selectiveSyncPolicy === 2;

    const handleSelectChange = (toggle) => {
        serviceWizard.setSelectiveSyncToggle(toggle);
    };

    // Sync is mandatory for this company so cannot opt out
    useEffect(() => {
        if (isSyncRequired) {
            serviceWizard.setSelectiveSyncToggle(true);
        }
    }, [isSyncRequired, serviceWizard, serviceWizard?.setSelectiveSyncToggle]);

    return (
        <FormControl
            data-testid="selective-sync-toggle-control"
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(true), width: '740px' }}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Selective Sync
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enable selective synchronisation of users and data.
                    </Text>
                </Box>
                <Box
                    flex={1}
                    paddingTop="22px"
                    maxWidth="400px"
                    sx={
                        isSyncRequired
                            ? {
                                  'label span[data-checked]': {
                                      opacity: 0.6,
                                      cursor: 'not-allowed',
                                  },
                              }
                            : undefined
                    }>
                    <Field
                        component={BooleanToggle}
                        id="selectiveSyncToggle"
                        name="selectiveSyncToggle"
                        isChecked={
                            isSyncRequired
                                ? true
                                : serviceWizard.selectiveSyncToggle
                        }
                        onChange={
                            isSyncRequired ? undefined : handleSelectChange
                        }
                        tabIndex={isSyncRequired ? -1 : undefined}
                        aria-disabled={isSyncRequired || undefined}
                    />
                    {isHovered && (
                        <FieldToolTip
                            label={
                                isSyncRequired
                                    ? 'Selective Sync is required'
                                    : 'Enable selective sync'
                            }
                            ariaLabel="selective-sync-toggle-tip"
                            left="25px"
                            bottom="5px"
                        />
                    )}
                </Box>
            </Stack>
        </FormControl>
    );
};

export default SelectiveSyncToggle;
